import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { firstAllowedPath } from "@/lib/admin-permissions";
import { useAuth } from "@/store";

/**
 * Несуществующий адрес. Показывается внутри консоли (с меню), чтобы оператор,
 * пришедший по старой или опечатанной ссылке, не терял навигацию; «На главную»
 * ведёт в первый доступный ему раздел, а не на «/», откуда его опять бы
 * перебросило.
 */
export function NotFoundPage() {
  const $ = _c(21);
  const {
    t
  } = useTranslation();
  const {
    pathname
  } = useLocation();
  const user = useAuth(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-5xl font-bold text-muted-foreground">404</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("notFound.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="text-xl font-semibold">{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== pathname || $[6] !== t) {
    t3 = t("notFound.text", {
      path: pathname
    });
    $[5] = pathname;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <p className="text-sm text-muted-foreground">{t3}</p>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== user) {
    t5 = firstAllowedPath(user);
    $[10] = user;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("notFound.home");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <Link to={t5} className="text-sm font-medium underline underline-offset-4">{t6}</Link>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t7) {
    t8 = <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center" data-testid="not-found">{t0}{t2}{t4}{t7}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}

/** Раздел есть, но у сотрудника нет права его открыть. */
function _temp(s) {
  return s.user;
}
export function AccessDeniedPage() {
  const $ = _c(18);
  const {
    t
  } = useTranslation();
  const user = useAuth(_temp2);
  let t0;
  if ($[0] !== user) {
    t0 = firstAllowedPath(user);
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const home = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-5xl font-bold text-muted-foreground">403</p>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("accessDenied.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <h1 className="text-xl font-semibold">{t2}</h1>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("accessDenied.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-sm text-muted-foreground">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== home || $[12] !== t) {
    t6 = home !== "/login" && <Link to={home} className="text-sm font-medium underline underline-offset-4">{t("accessDenied.home")}</Link>;
    $[11] = home;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center" data-testid="access-denied">{t1}{t3}{t5}{t6}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp2(s) {
  return s.user;
}